<h4>Search</h4>
<nz-table class="table-dark-zorro" [nzData]="list" [nzShowPagination]="false" nzSize="small">
	<thead>
		<tr>
			<th>Id</th>
			<th>Date</th>
			<th>Record Type</th>
			<th>Record Count</th>
			<th>Filters</th>
		</tr>
	</thead>
	<tbody>
		<ng-container *ngFor="let data of list; let i=index">
			<tr [ngClass]="{'table-active':i % 2 == 0}">
				<td [attr.rowspan]="data.filters.length==0?1:data.filters.length">{{data.id}}</td>
				<td [attr.rowspan]="data.filters.length==0?1:data.filters.length">{{data.date | date}}</td>
				<td [attr.rowspan]="data.filters.length==0?1:data.filters.length">{{data.recordType}}</td>
				<td [attr.rowspan]="data.filters.length==0?1:data.filters.length">{{data.recordCount}}</td>
				<td colspan="2" *ngIf="data.filters.length==0">No Filter</td>
				<td *ngIf="data.filters.length!=0">{{data.filters[0].filterName}}</td>
				<td *ngIf="data.filters.length!=0">{{data.filters[0].filterValue}}</td>
			</tr>
			<ng-container *ngFor="let filter of data.filters; let j = index">
				<tr *ngIf="j != 0" [ngClass]="{'table-active':i % 2 == 0}">
					<td>{{filter.filterName}}</td>
					<td>{{filter.filterValue}}</td>
				</tr>
			</ng-container>
		</ng-container>
	</tbody>
</nz-table>
